import type { GlobalConfig, RaterXPreset } from '../api/types/rater-x-preset';
import type { CustomizeQuoteState } from '../views/customize-quote/types';
import type { EditQuoteState } from '../views/edit-quote/types';
import type { UnderwriteQuoteState } from '../views/underwriter/types';

export const formatComponentGlobals = (
  components: RaterXPreset['components']
) => {
  return Object.entries(components || {}).reduce<Record<string, GlobalConfig>>(
    (acc, [product, component]) => {
      return {
        ...acc,
        [product]: component.global,
      };
    },
    {}
  );
};

const mergeComponentGlobalsIntoState = <
  T extends Partial<EditQuoteState & CustomizeQuoteState & UnderwriteQuoteState>
>(
  data: T
) => {
  const componentGlobals = formatComponentGlobals(data.raterX?.components);

  return {
    ...data,
    componentGlobals,
  };
};

export default mergeComponentGlobalsIntoState;
